import axios from 'utils/axios';

export type WorkspaceRole = 'owner' | 'admin' | 'editor' | 'viewer';

export interface Workspace {
  companyId: string;
  name: string;
  isOwner: boolean;
  role: WorkspaceRole;
  isDefault: boolean;
}

export interface WorkspaceMemberRow {
  id: string;
  role: WorkspaceRole;
  isOwner: boolean;
  status: 'active' | 'pending';
  email: string | null;
  name: string | null;
}

export interface InviteInfo {
  email: string;
  workspaceName: string;
  role: WorkspaceRole;
  hasAccount: boolean;
}

export const ROLE_LABELS: Record<WorkspaceRole, string> = {
  owner: 'Dono',
  admin: 'Administrador',
  editor: 'Editor',
  viewer: 'Visualizador'
};

const ACTIVE_KEY = 'familia-active-workspace';

export function getActiveWorkspaceId(): string | null {
  try {
    return localStorage.getItem(ACTIVE_KEY);
  } catch {
    return null;
  }
}

export function setActiveWorkspaceId(companyId: string | null): void {
  try {
    if (companyId) localStorage.setItem(ACTIVE_KEY, companyId);
    else localStorage.removeItem(ACTIVE_KEY);
  } catch {
    /* ignore */
  }
}

export async function listWorkspaces(): Promise<Workspace[]> {
  const { data } = await axios.get<{ data: Workspace[] }>('/finance/workspaces');
  return data.data;
}

export async function createWorkspace(name: string): Promise<Workspace> {
  const { data } = await axios.post<{ data: Workspace }>('/finance/workspaces', { name });
  return data.data;
}

// ---- membros / convites ----

export async function listWorkspaceMembers(companyId: string): Promise<WorkspaceMemberRow[]> {
  const { data } = await axios.get<{ data: WorkspaceMemberRow[] }>(`/finance/workspaces/${companyId}/members`);
  return data.data;
}

export async function inviteMember(companyId: string, email: string, role: WorkspaceRole, familyMemberId?: string) {
  const { data } = await axios.post(`/finance/workspaces/${companyId}/invite`, { email, role, familyMemberId });
  return data;
}

export async function updateMemberRole(companyId: string, memberId: string, role: WorkspaceRole) {
  const { data } = await axios.patch(`/finance/workspaces/${companyId}/members/${memberId}`, { role });
  return data;
}

export async function removeWorkspaceMember(companyId: string, memberId: string) {
  const { data } = await axios.delete(`/finance/workspaces/${companyId}/members/${memberId}`);
  return data;
}

// ---- aceite (público) ----

export async function getInviteInfo(token: string): Promise<InviteInfo> {
  const { data } = await axios.get<{ data: InviteInfo }>('/finance/workspaces/invite-info', { params: { token } });
  return data.data;
}

export async function acceptInvite(token: string, opts: { name?: string; password?: string }) {
  const { data } = await axios.post('/finance/workspaces/accept', { token, ...opts });
  return data;
}
